import { createCapsuleSession, completeCapsuleSession, submitCapsuleReflection } from "../api/apiHandler";

// POST /api/capsule/sessions/ — called on "Start Capsule"
export async function createSession({ mood, capsuleName, activity }) {
  const res = await createCapsuleSession({
    mood,
    capsule_name: capsuleName,
    activity,
  });
  return { sessionId: res.data.session_id };
}

// PATCH /api/capsule/sessions/{id}/complete/ — called on "Reflect now" or activity end
export async function completeSession(sessionId) {
  if (!sessionId) return;
  await completeCapsuleSession(sessionId);
}

// PATCH /api/capsule/sessions/{id}/reflection/ — called on reflection submit
export async function submitReflection({ sessionId, feeling, note }) {
  if (!sessionId) return;
  await submitCapsuleReflection(sessionId, {
    post_feeling: feeling,
    reflection_note: note || "",
  });
}
